import React from "react";
import './Events.css';

function Events() {
    const maxWidth = 900, minWidth = 600;
    const [dimensions, setDimensions] = React.useState({ 
        width: window.innerWidth < maxWidth ? window.innerWidth : maxWidth
      })
    const wait = React.useRef(false);
    
    React.useEffect(() => {
        function handleResize() {
            if (wait.current) {
                return;
            } else {
                wait.current = true;
                setTimeout(() => {
                    wait.current = false;
                    if(window.innerWidth < maxWidth){
                        setDimensions({
                            width: window.innerWidth
                        })
                    } else {
                        dimensions.width = maxWidth;
                    }
                }, 500)
            }
        }
        window.addEventListener('resize', handleResize)
    })

    if(window.innerWidth > minWidth){
        return(
            <div>
                <h2 className="eventHeader">Events</h2>
                <iframe id="googleCal" title="googleCal" src="https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23616161&ctz=America%2FDetroit&title=Quit-N-Time&showTitle=0&showDate=1&showNav=1&showPrint=0&showTabs=0&showCalendars=0&showTz=1&src=MGIzZDY1NGVjYTU1NDRiMGVlODhhNjY2OTYyMmMwNWFlMTRlNmNkM2MxOGUzYjk0NGFmY2FiNWM2ZDlhZGFlMUBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=ZW4udXNhI2hvbGlkYXlAZ3JvdXAudi5jYWxlbmRhci5nb29nbGUuY29t&color=%23616161&color=%23009688" width={dimensions.width-20} height={dimensions.width * 0.75} frameBorder="0" scrolling="no"></iframe>
            </div>
        )
    } else {
        return(
            <div>
                <h2 className="eventHeader">Events</h2>
                <iframe id="googleCal" title="googleCal" src="https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23616161&ctz=America%2FDetroit&showTitle=0&showNav=1&showDate=1&showPrint=0&showTabs=0&showCalendars=0&mode=AGENDA&title=Quit-N-Time&src=MGIzZDY1NGVjYTU1NDRiMGVlODhhNjY2OTYyMmMwNWFlMTRlNmNkM2MxOGUzYjk0NGFmY2FiNWM2ZDlhZGFlMUBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=ZW4udXNhI2hvbGlkYXlAZ3JvdXAudi5jYWxlbmRhci5nb29nbGUuY29t&color=%23616161&color=%23009688" width={dimensions.width-20} height={dimensions.width * 1.15} frameBorder="0" scrolling="no"></iframe>
            </div>
        )
    }

}

export default Events;